import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Heading,
  Spinner,
  Alert,
  Link,
} from '@printdeal/ui-library';
import { Link as GatsbyLink } from 'gatsby';
import { messages } from '../../../translations/complaint';
import ComplaintDetail from './ComplaintDetail';
import Head from '../../../../PrivateHead';
import { useComplaint } from '../../hooks/useComplaints';
import Breadcrumb from '../../../../Breadcrumb';
import { Complaint } from '../../../../../types/complaints';

const ComplaintDetailsPage = ({ complaintId }: { complaintId: string }) => {
  const intl = useIntl();
  const { complaint, status } = useComplaint(complaintId);

  return (
    <div className="data-sentry-block">
      <Head title={intl.formatMessage(messages.complaintDetailsPage)} />

      <Breadcrumb className="pd-mb-4">
        <Breadcrumb.Item to="../..">
          <FormattedMessage id="account.index.title" defaultMessage="My account" />
        </Breadcrumb.Item>
        <Breadcrumb.Item to="..">
          <FormattedMessage id="complaints.title" defaultMessage="My Complaints" />
        </Breadcrumb.Item>
        <Breadcrumb.Item isCurrentPage>
          <FormattedMessage id="complaints.details" defaultMessage="Complaint {complaintId}" values={{ complaintId }} />
        </Breadcrumb.Item>
      </Breadcrumb>

      <Heading size="1" className="pd-mb-6">
        <FormattedMessage id="complaints.details" defaultMessage="Complaint {complaintId}" values={{ complaintId }} />
      </Heading>

      {status === 'pending' && <Spinner variant="dim" screenReaderLabel="Loading..." className="pd-my-4" />}

      {status === 'error' && (
      <Alert className="pd-mb-3" variant="error">
        <FormattedMessage
          id="complaints.details.page.error.loading"
          defaultMessage="Something went wrong while fetching the complaint."
        />
      </Alert>
      )}
      {(status === 'success') && (
      <ComplaintDetail complaint={complaint as Complaint} />
      )}

      <Link
        as={GatsbyLink}
        to="../"
        iconBefore="chevron-left"
        variant="secondary"
      >
        <FormattedMessage id="complaints.backToComplaints" defaultMessage="Back to My complaints" />
      </Link>

    </div>
  );
};

export default ComplaintDetailsPage;
